import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "m-daterange-picker" }
const _hoisted_2 = { class: "m-daterange-picker__wrap" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "m-daterange-picker-calendarIcon" }, null, -1 /* HOISTED */)
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_dropdown = _resolveComponent("m-dropdown")!
  const _component_exact_modal = _resolveComponent("exact-modal")!
  const _component_manual_modal = _resolveComponent("manual-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_m_dropdown, {
        onOpen: _cache[0] || (_cache[0] = ($event: any) => (this.toggleMenu = !this.toggleMenu)),
        onClose: _cache[1] || (_cache[1] = ($event: any) => (this.toggleMenu = !this.toggleMenu)),
        zIndex: '99'
      }, {
        "button-content": _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("input", {
              value: $options.title,
              type: "text",
              class: "m-daterange-picker-input",
              placeholder: "Выберите дату"
            }, null, 8 /* PROPS */, _hoisted_3),
            _hoisted_4
          ])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.service.actions, (action) => {
            return (_openBlock(), _createElementBlock("span", {
              onClick: _withModifiers(($event: any) => ($options.selectAction(action)), ["stop"]),
              class: _normalizeClass(action.type === this.action?.type ? 'active' : '')
            }, _toDisplayString(action.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_5))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    ($data.showModal && $data.action.type === 'exact-date')
      ? (_openBlock(), _createBlock(_component_exact_modal, {
          key: 0,
          type: $data.action.type,
          "model-value": $props.modelValue,
          onSelectDate: $options.setValue,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($data.showModal = !$data.showModal))
        }, null, 8 /* PROPS */, ["type", "model-value", "onSelectDate"]))
      : _createCommentVNode("v-if", true),
    ($data.showModal && $data.action.type === 'manual-period')
      ? (_openBlock(), _createBlock(_component_manual_modal, {
          key: 1,
          modelValue: $data.interval,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.interval) = $event)),
          type: $data.action.type,
          onSelectDate: $options.setValue,
          onClose: _cache[4] || (_cache[4] = ($event: any) => ($data.showModal = !$data.showModal))
        }, null, 8 /* PROPS */, ["modelValue", "type", "onSelectDate"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}